<div *ngIf="type==1" >
<div *ngIf="list!=null">
    <div class=" border">
      <div class="padding-10" fxLayout="row">
        <b class="f20" style="font-size: 16px">{{title}}
        </b>
      </div>
      <mat-divider></mat-divider>
      <div>
        <div class="padding-10">
          <div>
            <div *ngFor="let item of list | keyvalue" fxLayout="column">
              <div fxFlex="100">

                <div style="padding-bottom: 5px;" *ngIf="item.key.includes ('Alcohol')" fxLayout="row"
                  fxLayoutAlign="start center">
                  <img height="40" class="img45" src="assets/medical/alochol.png" alt="alochol">
                  <span style="
                  font-weight: 500;">&nbsp; &nbsp;{{item.key.replace('_', ' ') }}&nbsp; </span>
                  <span class="ssa blackgrey">{{alcoholInteraction}}</span>
                </div>

                <div style="padding-bottom: 5px;" *ngIf="item.key.includes('Pregnancy')" fxLayout="row"
                  fxLayoutAlign="start center">
                  <img height="40" class="img45" src="assets/medical/Pregancy.png" alt="Pregancy">
                  <span style="
                  font-weight: 500;">&nbsp; &nbsp;{{item.key}}&nbsp;</span>
                  <span class="ssa blackgrey">{{PregnancyInteraction}}</span>
                </div>

                <div style="padding-bottom: 5px;" *ngIf="item.key.includes('Breast feeding')" fxLayout="row"
                  fxLayoutAlign="start center">
                  <img height="40" class="img45" src="assets/medical/Breast_Feeding.png" alt="Breast_Feeding">
                  <span style="
                  font-weight: 500;">&nbsp; &nbsp;{{item.key}}&nbsp;</span>
                  <span class="ssa blackgrey">{{BreastfeedingInteraction}}</span>
                </div>

                <div style="padding-bottom: 5px;" *ngIf="item.key.includes('Driving')" fxLayout="row"
                  fxLayoutAlign="start center">
                  <img height="40" class="img45" src="assets/medical/drive.png" alt="drive">
                  <span style="
                  font-weight: 500;">&nbsp; &nbsp;{{item.key}}&nbsp;</span>
                  <span class="ssa blackgrey">{{DrivingInteraction}}</span>
                </div>

                <div style="padding-bottom: 5px;" *ngIf="item.key.includes('Kidney')" fxLayout="row"
                  fxLayoutAlign="start center">
                  <img height="40" class="img45" src="assets/medical/Kidney.png" alt="Kidney">
                  <span style="
                  font-weight: 500;">&nbsp; &nbsp;{{item.key}}&nbsp;</span>
                  <span class="ssa blackgrey">{{KidneyInteraction}}</span>
                </div>

                <div style="padding-bottom: 5px;" *ngIf="item.key.includes('Liver')" fxLayout="row"
                  fxLayoutAlign="start center">
                  <img height="40" class="img45" src="assets/medical/Liver.png" alt="Liver">
                  <span style="
                  font-weight: 500;">&nbsp; &nbsp;{{item.key}}&nbsp;</span>
                  <span class="ssa blackgrey">{{LiverInteraction}}</span>
                </div>
              </div>
              <div fxLayout="row" fxFlex>
                <p class="blackColor wordBreak">{{item.value}} </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="type==2" >
  <div *ngIf="list!=null">
      <div class="padding-10">
        <div class="padding-10" fxLayout="row">
          <b class="f20 color468" style="font-size: 16px">{{title}}
          </b>
        </div>
        <div>
          <div class="padding-10 color468" >
            <div>
              <div *ngFor="let item of list | keyvalue" fxLayout="column">
                <div fxFlex="100">
  
                  <div style="padding-bottom: 5px;" *ngIf="item.key.includes ('Alcohol')" fxLayout="row"
                    fxLayoutAlign="start center">
                    <img height="40" class="img45" src="assets/medical/alochol.png" alt="alochol">
                    <span style="
                    font-weight: 500;">&nbsp; &nbsp;{{item.key.replace('_', ' ') }}&nbsp; </span>
                    <span class="ssa blackgrey">{{alcoholInteraction}}</span>
                  </div>
  
                  <div style="padding-bottom: 5px;" *ngIf="item.key.includes('Pregnancy')" fxLayout="row"
                    fxLayoutAlign="start center">
                    <img height="40" class="img45" src="assets/medical/Pregancy.png" alt="Pregancy">
                    <span style="
                    font-weight: 500;">&nbsp; &nbsp;{{item.key}}&nbsp;</span>
                    <span class="ssa blackgrey">{{PregnancyInteraction}}</span>
                  </div>
  
                  <div style="padding-bottom: 5px;" *ngIf="item.key.includes('Breast feeding')" fxLayout="row"
                    fxLayoutAlign="start center">
                    <img height="40" class="img45" src="assets/medical/Breast_Feeding.png" alt="Breast_Feeding">
                    <span style="
                    font-weight: 500;">&nbsp; &nbsp;{{item.key}}&nbsp;</span>
                    <span class="ssa blackgrey">{{BreastfeedingInteraction}}</span>
                  </div>
  
                  <div style="padding-bottom: 5px;" *ngIf="item.key.includes('Driving')" fxLayout="row"
                    fxLayoutAlign="start center">
                    <img height="40" class="img45" src="assets/medical/drive.png" alt="drive">
                    <span style="
                    font-weight: 500;">&nbsp; &nbsp;{{item.key}}&nbsp;</span>
                    <span class="ssa blackgrey">{{DrivingInteraction}}</span>
                  </div>
  
                  <div style="padding-bottom: 5px;" *ngIf="item.key.includes('Kidney')" fxLayout="row"
                    fxLayoutAlign="start center">
                    <img height="40" class="img45" src="assets/medical/Kidney.png" alt="Kidney">
                    <span style="
                    font-weight: 500;">&nbsp; &nbsp;{{item.key}}&nbsp;</span>
                    <span class="ssa blackgrey">{{KidneyInteraction}}</span>
                  </div>
  
                  <div style="padding-bottom: 5px;" *ngIf="item.key.includes('Liver')" fxLayout="row"
                    fxLayoutAlign="start center">
                    <img height="40" class="img45" src="assets/medical/Liver.png" alt="Liver">
                    <span style="
                    font-weight: 500;">&nbsp; &nbsp;{{item.key}}&nbsp;</span>
                    <span class="ssa blackgrey">{{LiverInteraction}}</span>
                  </div>
                </div>
                <div fxLayout="row" fxFlex>
                  <p class="blackColor wordBreak">{{item.value}} </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  